import { useEffect, useRef, useState } from 'react';

export const useDelayedAction = () => {
  const [isPending, setIsPending] = useState<boolean>(false);
  const timerRef = useRef<NodeJS.Timeout>(null);

  useEffect(() => {
    return cancel;
  }, []);

  function delay(action: () => unknown, delayTime: number) {
    cancel();
    setIsPending(true);
    timerRef.current = setTimeout(() => {
      setIsPending(false);
      action();
    }, delayTime);
  }

  function cancel() {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }

  return {
    isPending,
    delay,
    cancel,
  };
};
